import { render } from "./ShakenStirDeleteModal.vue?vue&type=template&id=4649645e"
import script from "./ShakenStirDeleteModal.vue?vue&type=script&lang=js"
export * from "./ShakenStirDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__